// src/pages/costing/PageSettings.jsx
import { useState } from "react";
import { fmt2 } from "../../utils/costingUtils";

export function PageSettings({ settings, onSettingsChange, onPackingPrice }) {
  const [labour,    setLabour]    = useState(settings.labourPerKg);
  const [custom,    setCustom]    = useState(settings.customPct);
  const [wastage,   setWastage]   = useState(settings.wastageGlobal ?? 1);
  const [pkgPrices, setPkgPrices] = useState(() =>
    Object.fromEntries(settings.packing.map(p => [p.id, p.price]))
  );
  return (
    <>
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">Global Settings</div>
          <div className="page-subtitle">All values flow into every product cost automatically</div>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
        <div className="settings-panel">
          <div className="settings-panel-title">⚙ Labour, Wastage & Margin</div>
          <div className="form-row">
            <span className="form-label" style={{ flex:1 }}>Labour & overhead</span>
            <input className="form-input input-right" style={{ width:90 }} type="number" step="0.01" value={labour}
              onChange={e => setLabour(e.target.value)}
              onBlur={e => { const v = parseFloat(e.target.value)||0; setLabour(v); onSettingsChange({...settings, labourPerKg:v}); }} />
            <span className="gl-unit">AED / kg</span>
          </div>
          <div className="form-row">
            <span className="form-label" style={{ flex:1 }}>Wastage %</span>
            <input className="form-input input-right" style={{ width:90 }} type="number" step="0.1" value={wastage}
              onChange={e => setWastage(e.target.value)}
              onBlur={e => { const v = parseFloat(e.target.value)||0; setWastage(v); onSettingsChange({...settings, wastageGlobal:v}); }} />
            <span className="gl-unit">%</span>
          </div>
          <div className="form-row">
            <span className="form-label" style={{ flex:1 }}>Custom margin %</span>
            <input className="form-input input-right" style={{ width:90 }} type="number" step="0.5" value={custom}
              onChange={e => setCustom(e.target.value)}
              onBlur={e => { const v = parseFloat(e.target.value)||0; setCustom(v); onSettingsChange({...settings, customPct:v}); }} />
            <span className="gl-unit">%</span>
          </div>
        </div>
        <div className="settings-panel">
          <div className="settings-panel-title">▦ Packing Materials</div>
          {settings.packing.map(p => (
            <div key={p.id} style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 0", borderBottom:"1px solid #f5f5f5" }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, fontWeight:600 }}>{p.label}</div>
                <div style={{ fontSize:10, color:"#aaa" }}>{p.size} kg / unit</div>
              </div>
              <input className="form-input input-right" style={{ width:90 }} type="number" step="0.01"
                value={pkgPrices[p.id] ?? p.price}
                onChange={e => setPkgPrices(old => ({...old, [p.id]:e.target.value}))}
                onBlur={e => { const v = parseFloat(e.target.value)||0; setPkgPrices(old => ({...old, [p.id]:v})); onPackingPrice(p.id, v); }} />
              <span className="gl-unit">AED</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
